import * as React from 'react';

interface Props {
    header: string;
    content: JSX.Element;
    image: string;
}

class MyAccountTile extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="my-account-tile">
                <h2 className="my-account-tile-header">
                    <img src={this.props.image} alt="account-header" />
                    {this.props.header}
                </h2>
                <div className="my-account-tile-container">{this.props.content}</div>
            </div>
        );
    }
}

export default MyAccountTile;



// WEBPACK FOOTER //
// ./src/view/MyAccountTile.tsx